import { FC, useState } from "react";
import { Empty, Spin } from "antd";
import {
  DIGITAL_HUMAN_SCOPE,
  digitalHumanScopeLabel,
  digitalHumanTrainStatusText,
  digitalHumanUsable,
  resolveDigitalHumanCoverUrl,
  resolveDigitalHumanVideoUrl,
} from "../../../service/digitalHuman";
import { useDigitalHumanPage } from "../useDigitalHumanPage";
import { PickerModal, PickerTabs } from "./PickerModal";

export const AvatarPickerModal: FC<{
  value?: string;
  valueId?: number | null;
  onClose: () => void;
  onConfirm: (avatar: { id: number; name: string }) => void;
}> = ({ value, valueId, onClose, onConfirm }) => {
  const [tab, setTab] = useState("public");
  const [pickedName, setPickedName] = useState(value || "");
  const [pickedId, setPickedId] = useState<number | null>(valueId ?? null);
  const scope =
    tab === "mine" ? DIGITAL_HUMAN_SCOPE.MINE : DIGITAL_HUMAN_SCOPE.PUBLIC;
  const { list, loading, loadingMore, hasMore, sentinelRef } = useDigitalHumanPage({
    scope,
    pageSize: 20,
    keepPreviousData: true,
  });

  return (
    <PickerModal
      eyebrow="AVATAR"
      title="选择数字人"
      width={720}
      onClose={onClose}
      footerLeft="透明形象可独立移动；原有素材仅支持整体调整"
      confirmText="确认选择"
      confirmDisabled={!pickedId || !pickedName}
      onConfirm={() => {
        if (pickedId && pickedName) onConfirm({ id: pickedId, name: pickedName });
      }}
    >
      <PickerTabs
        items={[
          { key: "public", label: "公共形象" },
          { key: "mine", label: "我的形象" },
        ]}
        value={tab}
        onChange={setTab}
      />
      <div className="adh-apk-panel">
        <Spin spinning={loading}>
          {list.length === 0 && !loading ? (
            <div className="adh-apk-empty">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="暂无数字人" />
            </div>
          ) : (
            <div className="adh-apk-grid">
              {list.map((a) => {
                const usable = digitalHumanUsable(a);
                const cover = resolveDigitalHumanCoverUrl(a);
                const coverVideo = resolveDigitalHumanVideoUrl(a);
                return (
                  <button
                    key={a.id}
                    type="button"
                    className={`adh-apk-card${pickedId === a.id ? " active" : ""}`}
                    disabled={!usable}
                    aria-disabled={!usable}
                    onClick={() => {
                      if (!usable) return;
                      setPickedId(a.id);
                      setPickedName(a.name);
                    }}
                  >
                    <span className="adh-apk-portrait">
                      <i />
                      {cover ? (
                        <img
                          src={cover}
                          alt=""
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      ) : coverVideo ? (
                        <video
                          src={`${coverVideo}#t=0.1`}
                          muted
                          playsInline
                          preload="metadata"
                          onError={(e) => {
                            e.currentTarget.style.display = "none";
                          }}
                        />
                      ) : null}
                    </span>
                    <strong>{a.name}</strong>
                    <small>
                      {digitalHumanTrainStatusText(a.trainStatus)} · {digitalHumanScopeLabel(a)}
                    </small>
                  </button>
                );
              })}
            </div>
          )}
        </Spin>
        <div className="adh-infinite-status" ref={sentinelRef}>
          {list.length > 0 ? (loadingMore ? "加载中…" : hasMore ? "" : "没有更多了") : null}
        </div>
      </div>
    </PickerModal>
  );
};
